<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- Toolbar -->
        <div class="toolbar" role="banner">
          Home
        </div>

        <div style="padding: 20px; background-color: rgb(252, 252, 252); height: 100%; border: 1px solid silver;">
          <div style="display: flex; justify-content: space-between;">
            <div>
              <h2>
                {{dashboardInfo?.companyName}}
              </h2>

              <div class="text-gray">
                {{dashboardInfo?.type}}, ID: {{dashboardInfo?.accountId}}
              </div>
            </div>

            <div style="display: flex;">
              <div *ngIf="dashboardInfo?.typeId==1" class="card-orange">
                <div class="header">
                  Group Account Balance
                </div>
                <div class="account-balance-holder">
                  {{dashboardInfo?.accountBalance | currency:'ZAR'}}
                </div>
              </div>

              <div class="card-orange">
                <div class="header">
                  Account Balance
                </div>
                <div class="account-balance-holder">
                  {{dashboardInfo?.accountBalance | currency:'ZAR'}}
                </div>
              </div>
            </div>
          </div>

          <h2 style="margin-top: 20px;">
            Merchant Account
          </h2>
          <div class="card-blue" style="display: flex; flex-direction: column;">
            <div style="display: flex; justify-content: space-between;">
              <div class="text-blue">
                {{dashboardInfo?.companyName}}
              </div>
              <div>
                <div class="text-gray text-size-12"> Account Id</div>
                <div style="text-align: right;">
                  {{dashboardInfo?.merchantAccount?.accountId}}
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <div>
                <div class="text-gray text-size-12"> Cash balance </div>
                <div class="text-large">
                  {{dashboardInfo?.merchantAccount?.balance | currency:'ZAR'}}
                </div>
              </div>
              <div>

                <dx-button stylingMode="contained" text="Add Money" type="normal" [width]="120"
                  (onClick)="showPopup($event)">
                </dx-button>

                <app-add-money />
              </div>
            </div>

          </div>

          <h2>Wallets</h2>

          <div style="display: flex;">
            <div *ngFor="let wallet of dashboardInfo?.wallets" class="card-gray"
              style="display: flex; flex-direction: column;">
              <div style="display: flex; justify-content: space-between;">
                <div class="header">
                  {{dashboardInfo?.companyName}}
                </div>

                <div class="cards-number">
                  {{wallet.numberOfCards}} Cards
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <div class="text-blue">
                  {{wallet?.name}}
                </div>
              </div>

              <div style="display: flex; justify-content: space-between;">
                <div>
                  <div class="text-gray text-size-10">
                    Cash Balance:
                  </div>
                  <div>
                    {{wallet.balanceOnCards | currency:'ZAR'}}
                  </div>
                </div>
                <div>
                  <div class="text-gray text-size-10">
                    Balance on Cards:
                  </div>
                  <div>
                    {{wallet.balanceOnCards | currency:'ZAR'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-grid">
          <h2 class="content-block">Transactions </h2>

          <div style="display: flex; justify-content: flex-end;">
            <dx-select-box [items]="datasourceReportType" displayExpr="text" valueExpr="value" [(value)]="reportType"
              placeholder="Select format" [width]="100">
            </dx-select-box>
            <dx-button stylingMode="outlined" text="Generate Statement" type="success" [width]="120"
              (onClick)="transactionReport($event)">
            </dx-button>
          </div>

          <dx-list [dataSource]="transactions" itemTemplate="listItem" [searchEnabled]="true"
            [searchExpr]="['merchantName', 'description']">
            <div *dxTemplate="let transaction of 'listItem'">
              <div style="display: flex; justify-content: space-between; border-bottom: 1px solid grey;">
                <div>
                  <div>
                    <span>
                      {{ transaction.merchantName }}
                    </span>
                    <span class="text-green text-size-10">
                      {{ transaction.status.description }}
                    </span>
                    <div class="text-gray mt5">
                      {{ transaction.description }}
                    </div>
                    <!-- <div class="text-size-12 text-blue mt5">
            {{ transaction.type }}
          </div> -->
                  </div>

                </div>
                <div>
                  <div
                    [ngClass]="{'positive-amount': transaction.amount > 0, 'negative-amount': transaction.amount < 0}">
                    {{ transaction.amount | currency:'ZAR' }}
                  </div>
                  <div class="text-gray text-size-10">
                    {{ transaction.created }}
                  </div>
                </div>

              </div>
            </div>
          </dx-list>
        </div>
      </div>
    </div>